import { Field } from 'factorial-form'

export const getFirstError = (field: Field | undefined) => {
  if (!field) return ''

  return field.errors ? field.errors[0] : ''
}
